const ambiente = process.env.REACT_APP_AMBIENTE
  ? process.env.REACT_APP_AMBIENTE
  : 'ONLINE';
const lmsConteudo = process.env.REACT_APP_LMS_CONTEUDO_API_URL;

function getUrlAmbiente(url) {
  if (!url) return '';
  if (url.includes('.vtt')) return url;
  const relativeUrl = getRelativeUrl(url);

  let lmsConteudoFormat = lmsConteudo.split('/');
  lmsConteudoFormat.pop();
  lmsConteudoFormat.pop();
  if (ambiente === 'ONLINE') {
    return 'https://assets.rockfeller.space/' + relativeUrl;
  } else if (ambiente === 'OFFLINE') {
    let newUrl = relativeUrl.split('/');
    newUrl.shift();
    newUrl.shift();
    //return `${lmsConteudoFormat.join('/')}/assets/${newUrl.join('/')}`;
    return `http://${window.location.hostname}:8030/assets/${newUrl.join('/')}`;
  }
}

export function getRelativeUrl(url) {
  if (!url) return '';
  const urlArr = url.split('/');
  urlArr.shift();
  urlArr.shift();
  urlArr.shift();
  const relativeUrl = urlArr.join('/');

  return relativeUrl;
}

export default getUrlAmbiente;
